import type { Reducer } from 'redux';
import { combineReducers } from 'redux';

// eslint-disable-next-line @lokalise/package-boundary -- should be refactored
import ContentEngineReducers from '@app/features/apps/pages/Management/components/ContentEngine/reducers';
// eslint-disable-next-line @lokalise/package-boundary -- should be refactored
import LoginReducers from '@app/features/auth/pages/LoginPage/reducers';
// eslint-disable-next-line @lokalise/package-boundary -- should be refactored
import ResetReducers from '@app/features/auth/pages/ResetPage/reducers';
// eslint-disable-next-line @lokalise/package-boundary -- should be refactored
import SSOReducers from '@app/features/auth/pages/SSOIndexPage/reducers';
// eslint-disable-next-line @lokalise/package-boundary -- should be refactored
import TwoFactorReducers from '@app/features/auth/pages/TwoFactorPage/reducers';
// eslint-disable-next-line @lokalise/package-boundary
import SignupReducers from '@app/features/auth/router/SignupRouter/reducers';
import CommentsReducers from '@app/features/comments/store/reducers';
import { reducers } from '@app/features/project';
// eslint-disable-next-line @lokalise/package-boundary -- should be refactored
import ProjectsReducers from '@app/features/project/pages/ProjectsList/reducers';
// eslint-disable-next-line @lokalise/package-boundary -- should be refactored
import SnapshotsReducers from '@app/features/project/pages/Settings/pages/ProjectSnapshots/reducers';
// eslint-disable-next-line @lokalise/package-boundary
import AdvancedSecurityReducers from '@app/features/team/pages/AdvancedSecurity/reducers';

import apiReducers from './api/reducers';
import integrationReducers from './externalApi/reducers';

type TeamState = {
    id: string;
    role: 'owner' | 'admin' | 'biller' | 'member';
    admin: boolean;
    name: string;
    owners: number[];
    projects: { id: string; name: string }[];
};

const initTeamState: TeamState = {
    id: '',
    role: 'owner',
    admin: false,
    name: '',
    owners: [],
    projects: [],
};

export type Branch = {
    id: string;
    // eslint-disable-next-line @typescript-eslint/naming-convention
    project_id: string;
    name: string;
    desc: string;
    // eslint-disable-next-line @typescript-eslint/naming-convention
    created_at: string;
    fullname: string;
};

export type SessionState = {
    userId: null | string;
    projectId: null | string;
    branchId: null | string;
    fullName: null | string;
    planId: null | string;
    email: null | string;
    planName?: string;
    trail: {
        daysLeft: number;
        message: boolean;
    };
    teamsCount: number;
    gravatarHash: string;
};

export type FeatureState = {
    [name: string]: string | boolean | null;
};

const initSessionState: SessionState = {
    userId: null,
    projectId: null,
    branchId: null,
    fullName: null,
    planId: null,
    email: null,
    planName: undefined,
    trail: {
        daysLeft: 0,
        message: false,
    },
    teamsCount: 1,
    gravatarHash: '',
};

const initOrdersState = { hasProjects: false };

const initialBranchState = {
    branchId: <string | null>null,
    branchName: '',
    branchToggle: false,
    list: <Branch[]>[],
};

const initFeatureState: FeatureState = {};

const TeamReducer: Reducer<typeof initTeamState> = (state = initTeamState) => state;
const SessionReducer: Reducer<typeof initSessionState> = (state = initSessionState) => state;
const OrdersReducer: Reducer<typeof initOrdersState> = (state = initOrdersState) => state;
const BranchReducer: Reducer<typeof initialBranchState> = (state = initialBranchState) => state;
const FeaturesReducer: Reducer<typeof initFeatureState> = (state = initFeatureState) => state;

export default combineReducers({
    advancedSecurity: AdvancedSecurityReducers,
    snapshots: SnapshotsReducers,
    team: TeamReducer,
    branch: BranchReducer,
    auth: combineReducers({
        login: LoginReducers,
        signup: SignupReducers,
        resetPassword: ResetReducers,
        twoFactor: TwoFactorReducers,
        sso: SSOReducers,
    }),
    session: SessionReducer,
    orders: OrdersReducer,
    projects: ProjectsReducers,
    comments: CommentsReducers,
    features: FeaturesReducer,
    contentEngine: ContentEngineReducers,
    ...reducers,
    ...apiReducers,
    ...integrationReducers,
});
